const rankings = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子', tag: '恋情曝光', hot: '128万', trend: 'up', change: '+3' },
  { rank: 2, title: '千万粉丝网红直播意外翻车现场', tag: '网红黑料', hot: '96万', trend: 'up', change: '+5' },
  { rank: 3, title: '知名综艺节目导演当场发飙离场', tag: '综艺翻车', hot: '87万', trend: 'up', change: '+12' },
  { rank: 4, title: '年度颁奖典礼后台女星互撕视频', tag: '吃瓜爆料', hot: '76万', trend: 'down', change: '-2' },
  { rank: 5, title: '某S+大制作剧组内部矛盾升级中', tag: '剧组路透', hot: '65万', trend: 'up', change: '+8' },
  { rank: 6, title: '代孕风波再起，多位艺人卷入调查', tag: '代孕风波', hot: '58万', trend: 'new', change: 'NEW' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">吃瓜热度榜</h2>
            <p className="text-foreground-500 text-sm">实时更新，数据来源于全平台阅读量</p>
          </div>
          <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
            <i className="ri-time-line"></i>
            <span>每5分钟更新</span>
          </div>
        </div>
        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          {rankings.map((item, idx) => {
            const rankColors = [
              'bg-primary-500 text-background-50',
              'bg-accent-500 text-background-50',
              'bg-secondary-500 text-background-50',
            ];
            const rankClass = item.rank <= 3 ? rankColors[item.rank - 1] : 'bg-background-200 text-foreground-500';

            return (
              <a
                key={item.rank}
                href="#ranking"
                className={`flex items-center gap-4 px-5 py-4 hover:bg-background-200/50 transition-colors duration-200 cursor-pointer ${
                  idx < rankings.length - 1 ? 'border-b border-background-200/60' : ''
                }`}
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold shrink-0 ${rankClass}`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className="text-[11px] text-primary-500 bg-primary-50 px-1.5 py-0.5 rounded whitespace-nowrap">{item.tag}</span>
                    <span className="text-xs text-foreground-400">{item.hot} 阅读</span>
                  </div>
                </div>
                <div className="flex items-center gap-1 shrink-0">
                  <span
                    className={`text-xs font-semibold whitespace-nowrap ${
                      item.trend === 'up'
                        ? 'text-primary-500'
                        : item.trend === 'down'
                          ? 'text-foreground-400'
                          : 'text-accent-500'
                    }`}
                  >
                    {item.trend === 'up' && <i className="ri-arrow-up-line mr-0.5"></i>}
                    {item.trend === 'down' && <i className="ri-arrow-down-line mr-0.5"></i>}
                    {item.change}
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}